'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DoubleRight;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
function DoubleRight(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 10 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 18 : _ref$height;

  return _react2.default.createElement(
    'svg',
    {
      focusable: 'false',
      'aria-hidden': true,
      className: 'icon-svg-chevron-double-right ' + className,
      width: width,
      height: height,
      viewBox: '0 0 10 18' },
    _react2.default.createElement('path', { d: 'M5.9765625,8.21428571 C5.9765625,8.30133972 5.94308069,8.37834788 5.87611607,8.4453125 L1.1953125,13.1261161 C1.12834788,13.1930807 1.05133972,13.2265625 0.964285714,13.2265625 C0.877231708,13.2265625 0.800223549,13.1930807 0.733258929,13.1261161 L0.231026786,12.6238839 C0.164062165,12.5569193 0.130580357,12.4799111 0.130580357,12.3928571 C0.130580357,12.3058031 0.164062165,12.228795 0.231026786,12.1618304 L4.17857143,8.21428571 L0.231026786,4.26674107 C0.164062165,4.19977645 0.130580357,4.12276829 0.130580357,4.03571429 C0.130580357,3.94866028 0.164062165,3.87165212 0.231026786,3.8046875 L0.733258929,3.30245536 C0.800223549,3.23549074 0.877231708,3.20200893 0.964285714,3.20200893 C1.05133972,3.20200893 1.12834788,3.23549074 1.1953125,3.30245536 L5.87611607,7.98325893 C5.94308069,8.05022355 5.9765625,8.12723171 5.9765625,8.21428571 Z M9.83370536,8.21428571 C9.83370536,8.30133972 9.80022355,8.37834788 9.73325893,8.4453125 L5.05245536,13.1261161 C4.98549074,13.1930807 4.90848258,13.2265625 4.82142857,13.2265625 C4.73437456,13.2265625 4.65736641,13.1930807 4.59040179,13.1261161 L4.08816964,12.6238839 C4.02120502,12.5569193 3.98772321,12.4799111 3.98772321,12.3928571 C3.98772321,12.3058031 4.02120502,12.228795 4.08816964,12.1618304 L8.03571429,8.21428571 L4.08816964,4.26674107 C4.02120502,4.19977645 3.98772321,4.12276829 3.98772321,4.03571429 C3.98772321,3.94866028 4.02120502,3.87165212 4.08816964,3.8046875 L4.59040179,3.30245536 C4.65736641,3.23549074 4.73437456,3.20200893 4.82142857,3.20200893 C4.90848258,3.20200893 4.98549074,3.23549074 5.05245536,3.30245536 L9.73325893,7.98325893 C9.80022355,8.05022355 9.83370536,8.12723171 9.83370536,8.21428571 Z' })
  );
}

DoubleRight.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Chevron/DoubleRight.js
// module id = 1148
// module chunks = 1